import { supabase } from "@/lib/supabaseClient";
import type { Property, PropertyInsert } from "@/lib/supabase/types";

export async function createProperty(input: PropertyInsert): Promise<Property> {
  const { data, error } = await supabase
    .from("properties")
    .insert(input)
    .select()
    .single();
  if (error) throw error;
  return data;
}

export async function listOrgProperties(orgId: string): Promise<Property[]> {
  const { data, error } = await supabase
    .from("properties")
    .select("*")
    .eq("org_id", orgId)
    .order("is_primary", { ascending: false })
    .order("created_at", { ascending: true });
  if (error) throw error;
  return data ?? [];
}
